"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStyle = void 0;
var bootstrap_style_1 = require("./bootstrap.style");
var list_style_1 = require("./list.style");
var font_style_1 = require("./font.style");
var icon_style_1 = require("./icon.style");
var loader_style_1 = require("./loader.style");
var toolbar_style_1 = require("./toolbar.style");
var body_style_1 = require("./body.style");
var html_style_1 = require("./html.style");
var autocomplete_google_1 = require("./autocomplete-google");
var colorGlobalVariables_style_1 = require("./colorGlobalVariables.style");
var widgetGlobal_style_1 = require("./widgetGlobal.style");
exports.GlobalStyle = "\n  ".concat(colorGlobalVariables_style_1.colorGlobalVariables, "\n  ").concat(bootstrap_style_1.bootstrapStyle, "\n  ").concat(widgetGlobal_style_1.widgetGlobalStyle, "\n  ").concat(font_style_1.fontStyle, "\n  ").concat(icon_style_1.iconStyle, "\n  ").concat(loader_style_1.loaderStyle, "\n  ").concat(list_style_1.listStyle, "\n  ").concat(toolbar_style_1.toolbarStyle, "\n  ").concat(body_style_1.bodyStyle, "\n  ").concat(html_style_1.htmlStyle, "\n  ").concat(autocomplete_google_1.AutocompleteGoogleStyle, "\n");
